import OpenHeader from "src/shared/components/OpenHeader";
import ResendEmailVerificationContainer from "../containers/EmailVerification/ResendEmailVerification";

const ResendEmailVerification = () => {
  return (
    <>
      <OpenHeader /> <ResendEmailVerificationContainer />
    </>
  );
};

export default ResendEmailVerification;
